export default "__VITE_ASSET__DAZDHhkS__"